import { render } from "./TyreTypesComponent.vue?vue&type=template&id=5bb29ca3&ts=true"
import script from "./TyreTypesComponent.vue?vue&type=script&lang=ts"
export * from "./TyreTypesComponent.vue?vue&type=script&lang=ts"

import "./TyreTypesComponent.vue?vue&type=style&index=0&id=5bb29ca3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__